/**
 * Fast variant of getAllTours.
 *
 * Same shape, same auth, same post-processing — just calls a leaner backend
 * callable that drops the per-tour `admin.auth().createCustomToken()` round
 * trip. Selected by `REACT_APP_USE_FAST_TOURS=true`. Falls back at any time
 * by flipping the env flag (no backend redeploy needed).
 */

import { getFunctions, httpsCallable } from 'firebase/functions';

import { getThumbnailUrlFromStorage } from './getThumbnailUrlFromStorage';
import { Tour } from 'app/types';

export async function getAllToursFast(id: string): Promise<Array<Tour>> {
  const functions = getFunctions();
  const fn = httpsCallable<{ user_id: string }, Tour[]>(
    functions,
    'tours-getAllToursFast',
  );

  try {
    const result = await fn({ user_id: id });
    if (!result.data) return [];

    return Promise.all(
      result.data.map(async (tour: Tour): Promise<Tour> => {
        if (!tour.thumbnailUrl) return tour;
        try {
          const url = await getThumbnailUrlFromStorage(tour.thumbnailUrl);
          return { ...tour, thumbnailUrl: url };
        } catch {
          return tour;
        }
      }),
    );
  } catch (err) {
    console.error('[getAllToursFast]', err);
    throw err;
  }
}
